<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('index.language')}}</div>
        </div>
        <div class="cotainer language" :class="{mn: language == 'ar'}">
            <ul class="ul-box" v-if="language == 'ar'">
                <li class="li" @click="lang('en')">
                    <div class="text">English</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/yg.png" alt="">
                    <div class="arrow" v-show="language == 'en'"></div>
                </li>
                <li class="li" @click="lang('es')">
                    <div class="text">Español</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/xby.png" alt="">
                    <div class="arrow" v-show="language == 'es'"></div>
                </li>
                <li class="li" @click="lang('fr')">
                    <div class="text">français</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/fg.png" alt="">
                    <div class="arrow" v-show="language == 'fr'"></div>
                </li>
                <li class="li" @click="lang('de')">
                    <div class="text">Deutsche</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/dg.png" alt="">
                    <div class="arrow" v-show="language == 'de'"></div>
                </li>
                <li class="li" @click="lang('jp')">
                    <div class="text">日本語</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/rb.png" alt="">
                    <div class="arrow" v-show="language == 'jp'"></div>
                </li>
                <li class="li" @click="lang('ar')">
                    <div class="text">عربي</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/alb.png" alt="">
                    <div class="arrow" v-show="language == 'ar'"></div>
                </li>
                <li class="li" @click="lang('kr')">
                    <div class="text">한국어</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/hg.png" alt="">
                    <div class="arrow" v-show="language == 'kr'"></div>
                </li>
                <li class="li" @click="lang('th')">
                    <div class="text">ไทย</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/tg.png" alt="">
                    <div class="arrow" v-show="language == 'th'"></div>
                </li>
                <li class="li" @click="lang('vn')">
                    <div class="text">Tiếng Việt</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/yn.png" alt="">
                    <div class="arrow" v-show="language == 'vn'"></div>
                </li>
                <li class="li" @click="lang('zh')">
                    <div class="text">简体中文</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/zh.png" alt="">
                    <div class="arrow" v-show="language == 'zh'"></div>
                </li>
                <li class="li" @click="lang('tw')">
                    <div class="text">繁體中文</div>
                    <img class="icon" style="margin: 0 0 0 .2rem" src="@/assets/lang/tw.png" alt="">
                    <div class="arrow" v-show="language == 'tw'"></div>
                </li>
            </ul>
            <ul class="ul-box" v-else>
                <li class="li" @click="lang('en')">
                    <img class="icon" src="@/assets/lang/yg.png" alt="">
                    <div class="text">English</div>
                    <div class="arrow" v-show="language == 'en'"></div>
                </li>
                <li class="li" @click="lang('es')">
                    <img class="icon" src="@/assets/lang/xby.png" alt="">
                    <div class="text">Español</div>
                    <div class="arrow" v-show="language == 'es'"></div>
                </li>
                <li class="li" @click="lang('fr')">
                    <img class="icon" src="@/assets/lang/fg.png" alt="">
                    <div class="text">français</div>
                    <div class="arrow" v-show="language == 'fr'"></div>
                </li>
                <li class="li" @click="lang('de')">
                    <img class="icon" src="@/assets/lang/dg.png" alt="">
                    <div class="text">Deutsche</div>
                    <div class="arrow" v-show="language == 'de'"></div>
                </li>
                <li class="li" @click="lang('jp')">
                    <img class="icon" src="@/assets/lang/rb.png" alt="">
                    <div class="text">日本語</div>
                    <div class="arrow" v-show="language == 'jp'"></div>
                </li>
                <li class="li" @click="lang('ar')">
                    <img class="icon" src="@/assets/lang/alb.png" alt="">
                    <div class="text">عربي</div>
                    <div class="arrow" v-show="language == 'ar'"></div>
                </li>
                <li class="li" @click="lang('kr')">
                    <img class="icon" src="@/assets/lang/hg.png" alt="">
                    <div class="text">한국어</div>
                    <div class="arrow" v-show="language == 'kr'"></div>
                </li>
                <li class="li" @click="lang('th')">
                    <img class="icon" src="@/assets/lang/tg.png" alt="">
                    <div class="text">ไทย</div>
                    <div class="arrow" v-show="language == 'th'"></div>
                </li>
                <li class="li" @click="lang('vn')">
                    <img class="icon" src="@/assets/lang/yn.png" alt="">
                    <div class="text">Tiếng Việt</div>
                    <div class="arrow" v-show="language == 'vn'"></div>
                </li>
                <li class="li" @click="lang('zh')">
                    <img class="icon" src="@/assets/lang/zh.png" alt="">
                    <div class="text">简体中文</div>
                    <div class="arrow" v-show="language == 'zh'"></div>
                </li>
                <li class="li" @click="lang('tw')">
                    <img class="icon" src="@/assets/lang/tw.png" alt="">
                    <div class="text">繁體中文</div>
                    <div class="arrow" v-show="language == 'tw'"></div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'language',
    data () {
        return {
            language: 'en',
            theme: false
        }
    },
    created(){
      this.language = localStorage.getItem('language') || "en";
      this.theme = JSON.parse(localStorage.getItem('theme'));
    },
    mounted() {

    },
    methods: {
       back(){
           this.$router.go(-1);
       },
       lang(lg){
           this.language = lg;
           localStorage.removeItem('country');
           localStorage.setItem('language',lg);
           this.$router.go(-1);
           setTimeout(()=>{
             window.location.reload();
           },100);
       }
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .ul-box{
        padding: 0 .3rem;
        background: #fff;
    }
    .cotainer .ul-box .li{
        position: relative;
        display: flex;
        align-items: center;
        padding: .4rem 0;
        color: #000;
        font-size: .42rem;
        border-bottom: 1px solid #b0bfd7;
    }
    .cotainer .ul-box .li .icon{
        width: .72rem;
        margin-right: .2rem;
        border-radius: 50%;
    }
    .cotainer .ul-box .li:last-child{
        border-bottom: none;
    }
    .cotainer .ul-box .li .arrow{
        position: absolute;
        right: .2rem;
        width: 15px;
        height: 8px;
        border-left: 2px solid #4bb3e8;
        border-bottom: 2px solid #4bb3e8;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
    }
    .cotainer.mn .ul-box .li .arrow{
      left: .2rem;
      right: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/language.vue